import { Box } from '@mui/material';

const BlocksMessage = ({ blocks = [], handleAddNode, blockSize = {}, paddingX = 0 }) => {
  const { width = '75px', height = '75px' } = blockSize;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, my: 2, px: paddingX }}>
      {blocks.map((step, index) => (
        <Box
          key={index}
          sx={{
            width,
            height,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#fff',
            border: '2px dashed #ccc',
            borderRadius: '5px',
            fontWeight: 'bold',
            fontSize: 'small',
            cursor: 'pointer',
            padding: '8px',
            color: '#333',
            textAlign: 'center',
            wordBreak: 'break-word',
            '&:hover': {
              backgroundColor: '#f5f5f5',
            },
          }}
          onClick={() => handleAddNode(step)}
        >
          {step.currentNode?.nodeName || 'Unnamed'}
        </Box>
      ))}
    </Box>
  );
};

export default BlocksMessage;
